import React from "react";



const FileInput = ({ value, onChange, ...rest }) => (
  <div className="File-input">
    {Boolean(value.length) && (
      <div>Selected files: {value.map((f) => f.name).join(", ")}</div>
    )}
    <label className="" for="file-upload">
      {/* <div className="Button-icon"> Click Here */}
      {/* </div> */}
      Upload an Image
    </label>
    {/* <div className="Button-text">To Add Image</div> */}
  
    <input
        id="file-upload"
        name="file-upload"
        {...rest}
        style={{ display: "none" }}
        type="file"
        onChange={(e) => {
          onChange([...e.target.files]);
          e.target.value = null;
        }}
      />

  </div>
);

export default FileInput;
